import { defineMessages } from 'react-intl';

const messages = defineMessages({
  wassIdLabel: {
    id: 'App.ManageHudVoucherDetails.NewTenantEvents.SubmitEventsToTracsModal.WassIdLabel',
    defaultMessage: 'WASS ID',
  },
  wassIdTooltip: {
    id: 'App.ManageHudVoucherDetails.NewTenantEvents.SubmitEventsToTracsModal.WassIdTooltip',
    defaultMessage:
      "Use your WASS credentials that are used to log into HUD's Secure Systems portal.",
  },
  wassIdPlaceholder: {
    id: 'App.ManageHudVoucherDetails.NewTenantEvents.SubmitEventsToTracsModal.WassIdPlaceholder',
    defaultMessage: 'Enter your WASS ID',
  },
  passwordLabel: {
    id: 'App.ManageHudVoucherDetails.NewTenantEvents.SubmitEventsToTracsModal.PasswordLabel',
    defaultMessage: 'Password',
  },
  passwordPlaceholder: {
    id: 'App.ManageHudVoucherDetails.NewTenantEvents.SubmitEventsToTracsModal.PasswordPlaceholder',
    defaultMessage: 'Enter your password',
  },
  buttonText: {
    id: 'App.ManageHudVoucherDetails.NewTenantEvents.SubmitEventsToTracsModal.ButtonText',
    defaultMessage: 'Submit Events to TRACS',
  },
  cancel: {
    id: 'App.ManageHudVoucherDetails.NewTenantEvents.SubmitEventsToTracsModal.Cancel',
    defaultMessage: 'Cancel',
  },
});

export default messages;
